import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { IRizivHearingAidDefinitionV2FilterData } from 'gen/ApiClient';

export const RizivHifsFilterDataContext = React.createContext<ICacheContext<IRizivHearingAidDefinitionV2FilterData>>(undefined as any);
